import { mapActions, mapGetters } from 'vuex'
import { eventBus } from '@/main'
import moment from 'moment'

export default {
    computed: {
        ...mapGetters({
            yearReceived: 'years/Year',
        }),
    },
    methods: {
        ...mapActions({
            FetchYearByAcademicSession: 'years/FetchYearByAcademicSession',
        }),
        LoadYearByAcademicSession(academicSession) {
            eventBus.$emit('year-fetch:started');
            this.FetchYearByAcademicSession({ AcademicSession: academicSession })
                .then(() => {
                    this.year = Object.assign({}, this.yearReceived);
                    eventBus.$emit('year-fetch:success');
                })
                .catch(error => eventBus.$emit('alert:error', error))
                .finally(() => eventBus.$emit('year-fetch:finished'));
        },
    },
};
